import CX from 'classnames'
import * as React from 'react'
import { EventLog } from '../../types/api'
import { EventLogEntry } from './components/EventLogEntry'
import { CONDENSED_LOG_SIZE } from './constants'

interface Props {
  eventLogs: EventLog[]
  collapsed: boolean
}

const EventLogTimeline: React.FC<Props & React.HTMLProps<HTMLDivElement>> = ({ eventLogs, collapsed, ...divProps }) => {
  const displayableEventLogs = eventLogs.filter((e: EventLog) => e.message)
  const events = collapsed ? displayableEventLogs.slice(0, CONDENSED_LOG_SIZE) : displayableEventLogs
  const unorderedListClass = displayableEventLogs.length === 1 ? 'only-one-event' : null
  return (
    <div className={CX('event-log-timeline', { collapsed })} {...divProps}>
      <ul className={unorderedListClass}>
        {events.map((e: EventLog) => (
          <li key={`timeline-${e.id}`}>
            {/* The hover state overflows the parent element by about 15px on the left and right side. */}
            {/* It looks nice in our current components, but if you're re-using this the css may need to be reworked */}
            <div className="row-highlight" />
            <EventLogEntry eventLog={e} />
          </li>
        ))}
      </ul>
    </div>
  )
}

export { EventLogTimeline }
